export enum AlertVariant {
  Error = 'error',
  Informational = 'informational',
  Success = 'success',
}
